import { apiSlice } from '../app/api/apiSlice';

export const referralApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReferralLogs: builder.query({
      query: ({ page = 1, limit = 10, search = '', reward_status = '' } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        if (search) params.append('search', search);
        if (reward_status) params.append('reward_status', reward_status);

        return {
          url: `admin/referrals/logs${params.toString() ? `?${params.toString()}` : ''}`,
        };
      },
      validateStatus: (response, result) => response.status === 200 && !result.isError,
    }),
  }),
});

export const { useGetReferralLogsQuery, useLazyGetReferralLogsQuery } = referralApiSlice;
